<template>
  <div
    :style="btnStyle"
    :title="tooltip"
    class="d-flex align-items-center justify-content-center"
    :class="[
      { 'flex-column': !horizontal },
      { traslateEfect: traslate },
      { traslateEfectLoop: traslateSelected },
      { activeBtn: active },
      { inactiveBtn: inactive },
      { contenedor: !inactive },
      { contenedor_inactive: inactive },
    ]"
  >
  <!-- v-if="!inactive" -->
    <!-- Icon -->
    <i
      class="icon"
      :class="[icon, { activeIcon: active, inactiveIcon: inactive }]"
    ></i>

    <!-- Text -->
    <div class="text" v-text="text" :class="{ 'ml-2': icon }"></div>
  </div>
</template>

<script>
export default {
  props: {
    size: Number, // Tamaño del texto e icono
    color: String, // Color del boton
    text: String, // Texto del botón
    tooltip: String, // Texto a mostrar cuando se deja el mouse encima del botón
    icon: String, // Icono del botón
    width: Number, // Ancho del botón
    height: Number, // tamaño del botón
    url: String, // Url del botón
    colorText: { type: String, default: "#222222" }, // Color de texto
    round: Boolean, // Convierte el botón cuadrado a circular
    horizontal: Boolean, // Convierte el botón cuadrado en horizontal
    traslate: Boolean, // Mueve el botón rigeramente hacia arriba al pasar el mouse por encima
    traslateSelected: Boolean,
    active: Boolean, // Función que pinta el botón indicando que esta seleccionado
    inactive: Boolean,
    fullWidth: Boolean
  },
  computed: {
    btnStyle() {
      return {
        "--bg-color": this.inactive ? "grey" : this.color,
        "--text-color": this.inactive ? "grey" : this.colorText,
        "--size-text": this.size / 1.7 + "px",
        "--size-icon": this.size + "px",
        "--width": !this.fullWidth ? this.width + "px" : "100%",
        "--height": this.height ? this.height + "px" : this.width + "px",
        "--round": this.round ? "100px" : "5px",
      };
    },
  },
};
</script>

<style scoped>
.contenedor {
  padding: 10px;
  /* background: var(--bg-color) !important; */
  border: 1px solid var(--bg-color) !important;
  color: var(--bg-color);
  width: var(--width) !important;
  height: var(--height) !important;
  border-radius: var(--round);
  opacity: 0.85;
  transition: 0.3s;
}

.contenedor_inactive {
  padding: 10px;
  /* background: var(--bg-color) !important; */
  border: 1px solid var(--bg-color) !important;
  color: var(--bg-color);
  width: var(--width) !important;
  height: var(--height) !important;
  border-radius: var(--round);
  opacity: 0.85;
  transition: 0.3s;
  pointer-events: none;
}

.contenedor:hover > i,
.contenedor:hover {
  opacity: 1;
  transition: 0.3s;
  cursor: pointer;
  background: var(--bg-color) !important;
  color: var(--text-color) !important;
}


.traslateEfect:hover {
  transform: translateY(-5px);
}

.traslateEfectLoop{
  -webkit-animation: traslateLoop 1s linear 0s infinite;
  -moz-animation: traslateLoop 1s linear 0s infinite;
  animation: traslateLoop 1s linear 0s infinite;
}

@keyframes traslateLoop {
  0% {
    transform: translateY(0px);
  }

  25% {
    transform: translateY(-5px);
  }

  50% {
    transform: translateY(0px);
  }

  75% {
    transform: translateY(-5px);
  }

  100% {
    transform: translateY(0px);
  }
}



.icon {
  font-size: var(--size-icon) !important;
  color: var(--bg-color);
}

.text {
  font-size: var(--size-text) !important;
}

.activeBtn {
  opacity: 1 !important;
  cursor: pointer !important;
  background: var(--bg-color) !important;
  color: var(--text-color) !important;
}
.inactiveBtn {
  opacity: 1 !important;
  cursor: not-allowed !important;
  background: #fff !important;
  color: grey !important;
}

.activeIcon {
  color: var(--text-color);
}

.inactiveIcon {
  color: grey;
}
</style>
